import React from "react";
import { FaCalendarAlt, FaUser, FaEnvelope, FaPhone, FaGamepad, FaMoneyBillWave, FaTag } from "react-icons/fa";
import FormField from "../components/FormField";

const RecapItem = ({ label, value, icon: Icon }) => {
  if (!value) return null;
  return (
    <div className="flex items-center gap-3 py-1.5 border-b border-border/20 last:border-0">
      {Icon && <Icon className="h-3 w-3 text-primary shrink-0" />}
      <span className="text-xs text-muted-foreground w-24 shrink-0">{label}</span>
      <span className="text-xs font-medium text-foreground flex-1 truncate">{value}</span>
    </div>
  );
};

export const Step4 = ({ values, isInvited = false }) => (
  <div className="flex flex-col gap-3 step-enter">
    <div>
      <h2 className="text-base font-bold text-foreground">Signature</h2>
      <p className="text-xs text-muted-foreground mt-0.5">Dernière étape — vérifie et signe.</p>
    </div>

    <FormField name="dateSignature" label="Date de signature" icon={FaCalendarAlt} type="date" required />

    <div className="card-pad px-4 py-3">
      <p className="text-[10px] font-bold text-muted-foreground uppercase tracking-widest mb-1.5">
        Récapitulatif
      </p>
      <RecapItem label="Nom"        value={values.nom}                          icon={FaUser}          />
      <RecapItem label="Prénom"     value={values.prenom}                       icon={FaUser}          />
      <RecapItem label="Pseudo"     value={values.pseudo}                       icon={FaUser}          />
      <RecapItem label="Email"      value={values.email}                        icon={FaEnvelope}      />
      <RecapItem label="Téléphone"  value={values.telephone}                    icon={FaPhone}         />
      <RecapItem label="Domaine(s)" value={values.domainePratique?.join(", ")}  icon={FaGamepad}       />
      {!isInvited && <RecapItem label="Statut"   value={values.statut}       icon={FaTag}           />}
      {!isInvited && <RecapItem label="Paiement" value={values.modePaiement} icon={FaMoneyBillWave} />}
    </div>
  </div>
);
